/**
 * Abstract Singleton Storage Interfaces using a standardized
 *     storage object type and expiration policy.
 * @abstract
 * @name abstract-storage
 */
define('abstract-storage/abstract-storage',['require','exports','module'],function(require,exports,module){

    /**
     * Storage object constructor.  Used as a standard container
     * for stored data in abstract-storage implementations.
     * @constructor
     * @param {string} key     internal reference to storage key for the object instance.
     * @param {mixed}  value   value to stored.
     * @param {number} expires make the storage object expired after expire seconds. 
     *                         (-1 denotes a permanent object - no expire)
     */
    function StorageEntry(key,value,expires){
        this.created=(new Date().getTime());
        this.expired=0;
        this.expires=expires;
        this.key=key;
        this.value=value;

    }
        /**
         * Procedure for retrieving a storage object.
         * If expired as dicated by the created and expires properties,
         * the object will be marked accordingly via the expired property.
         * (If none exists, return an empty expired object)
         * 
         * @param  {object} so  A storage object to be evaluated for retrieval.
         * @return {object}     Object so or an "empty" storage object.
         */
    var get = function(so){
            if(so && (so.expires=="-1" || (so.expires*1000 > ((new Date()).getTime() - so.created)))) {
                return  so;
            }
            expire(so);
            return so || getEmpty();
        },

        /**
         * Return an "empty", data-less storage object.          
         * @return {object}     Object so or an "empty" storage object.
         */
        getEmpty=function(){
            return {"expired":1, "created": 0};
        },

        /**
         * Mark a storage object as expired.
         * @param  {object} so  Storage object to expire.
         */
        expire=function(so) {
            if(so){
                so.expired=1;
            }
        },

        /**
         * Mark a storage object as expired.
         * @param  {object} so  Storage object to expire.
         * @return {object}     Object so or an "empty" storage object.
         */
        storable = function(key,value,expires){
            return new StorageEntry(key,value,expires);
            //return {"key":key, "value": value, "expires": expires, "expired": 0, "created": (new Date().getTime())}
        };
    
    module.exports={
        /**
         * Expose the StorageEntry object for testing.
         * @type {constructor}
         */
        StorageEntry : StorageEntry,
        /**
         * @see expire
         * @type {function}
         */
        expire  : expire,
        /**
         * @see get
         * @type {function}
         */
        get     : get,
        /**
         * @see storable
         * @type {function}
         */
        storable: storable,
        /**
         * @see getEmpty
         * @type {function}
         */
        getEmpty: getEmpty
    };

});
